import { motion as m } from "framer-motion";
import {
  Edit2,
  FilterRemove,
} from "iconsax-react";
import FilterTextInput from "../FilterTextInput";
import { TAG_MANAGEMENT_EDIT } from "../../Router/path";
import { useNavigate } from "react-router-dom";
import Paginator from "../Paginator";
import Can from "../Can";
const TagTable = ({
  data = [],
  meta,
  handlePageClick,
  searchTerm,
  handleSearch,
  handleKeyDown,
  handlePerPageChange,
  perPage,
  editable = false,
  clearFilter,
}) => {
  const navigate = useNavigate();

  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Search bar */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        <div className="flex gap-[8px] items-center">
          {clearFilter && searchTerm !== "" && (
            <FilterRemove
              size="16"
              onClick={clearFilter}
              variant="Bold"
              className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
            />
          )}
          <FilterTextInput
            value={searchTerm}
            onChange={handleSearch}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>

      {/* Table Data */}
      <div className="flex w-full h-full gap-[24px] overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No tags found
          </div>
        ) : (
          <div className="w-full">
            <table className="w-full">
              {/* Table Header */}
              <thead>
                <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
                  <th className="w-3/6 text-start px-[24px] py-[16px]">
                    Tag Name
                  </th>
                  <th className="w-1/6 text-start px-[24px] py-[16px]">
                    Count
                  </th>
                  <th className="w-1/6 text-start px-[24px] py-[16px]">
                    Color
                  </th>
                  <th className="w-1/6 text-start px-[24px] py-[16px]"></th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {data &&
                  data.map((item, index) => (
                    <tr
                      key={item.id}
                      className="w-full font-normal border-b last:border-none border-[#EFF0F2]"
                    >
                      <td className="px-[24px] py-[16px]">
                        {item.name ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.guests_count ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        <div
                          className="p-4 w-fit rounded-full"
                          style={{ backgroundColor: item.color }}
                        />
                      </td>
                      {editable && (
                        <td className="flex px-[24px] py-[16px] justify-end">
                          <div className="flex items-center gap-3">
                            <Can permission="edit_tag">
                              {/* <span className="flex text-[#FF0000] text-[14px] items-center hover:underline cursor-pointer">
                              <CloseCircle size="15" variant="Bold" />
                              Remove
                            </span> */}
                              <span
                                className="flex text-[#5C4BF5] text-[14px] items-center hover:underline cursor-pointer"
                                onClick={() =>
                                  navigate(TAG_MANAGEMENT_EDIT, {
                                    state: item.id,
                                  })
                                }
                              >
                                <Edit2 size="15" variant="Bold" />
                                Edit
                              </span>
                            </Can>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
          handlePageClick={handlePageClick}
        />
      )}
    </m.div>
  );
};

export default TagTable;
